export default {"src":"/_next/static/media/jacks-testimonial.5f33910c.svg","height":17,"width":71,"blurWidth":0,"blurHeight":0};